export const menLevelThree=[
    {
      "name": "Men T-Shirts",
      "categoryId": "men_t_shirts",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Casual Shirts",
      "categoryId": "men_casual_shirts",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Formal Shirts",
      "categoryId": "men_formal_shirts",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Sweatshirts",
      "categoryId": "men_sweatshirts",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Sweaters",
      "categoryId": "men_sweaters",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Jackets",
      "categoryId": "men_jackets",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Blazers & Coats",
      "categoryId": "men_blazers_and_coats",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Suits",
      "categoryId": "men_suits",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Rain Jackets",
      "categoryId": "men_rain_jackets",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Indian & Festive Wear",
      "categoryId": "men_indian_and_festive_wear",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Kurtas & Kurta Sets",
      "categoryId": "men_kurtas_and_kurta_sets",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Sherwanis",
      "categoryId": "men_sherwanis",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Nehru Jackets",
      "categoryId": "men_nehru_jackets",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Dhotis",
      "categoryId": "men_dhotis",
      "parentCategoryName": "Topwear",
      "parentCategoryId": "men_topwear"
    },
    {
      "name": "Men Jeans",
      "categoryId": "men_jeans",
      "parentCategoryName": "Bottomwear",
      "parentCategoryId": "men_bottomwear"
    },
    {
      "name": "Men Casual Trousers",
      "categoryId": "men_casual_trousers",
      "parentCategoryName": "Bottomwear",
      "parentCategoryId": "men_bottomwear"
    },
    {
      "name": "Men Formal Trousers",
      "categoryId": "men_formal_trousers",
      "parentCategoryName": "Bottomwear",
      "parentCategoryId": "men_bottomwear"
    },
    {
      "name": "Men Shorts",
      "categoryId": "men_shorts",
      "parentCategoryName": "Bottomwear",
      "parentCategoryId": "men_bottomwear"
    },
    {
      "name": "Men Track Pants & Joggers",
      "categoryId": "men_track_pants_and_joggers",
      "parentCategoryName": "Bottomwear",
      "parentCategoryId": "men_bottomwear"
    },
    {
      "name": "Men Briefs & Trunks",
      "categoryId": "men_briefs_and_trunks",
      "parentCategoryName": "Innerwear & Sleepwear",
      "parentCategoryId": "men_innerwear_and_sleepwear"
    },
    {
      "name": "Men Boxers",
      "categoryId": "men_boxers",
      "parentCategoryName": "Innerwear & Sleepwear",
      "parentCategoryId": "men_innerwear_and_sleepwear"
    },
    {
      "name": "Men Vests",
      "categoryId": "men_vests",
      "parentCategoryName": "Innerwear & Sleepwear",
      "parentCategoryId": "men_innerwear_and_sleepwear"
    },
    {
      "name": "Men Sleepwear & Loungewear",
      "categoryId": "men_sleepwear_and_loungewear",
      "parentCategoryName": "Innerwear & Sleepwear",
      "parentCategoryId": "men_innerwear_and_sleepwear"
    },
    {
      "name": "Men Thermals",
      "categoryId": "men_thermals",
      "parentCategoryName": "Innerwear & Sleepwear",
      "parentCategoryId": "men_innerwear_and_sleepwear"
    },
    {
      "name": "Men Plus Size",
      "categoryId": "men_plus_size",
      "parentCategoryName": "Innerwear & Sleepwear",
      "parentCategoryId": "men_innerwear_and_sleepwear"
    },
    {
      "name": "Men Casual Shoes",
      "categoryId": "men_casual_shoes",
      "parentCategoryName": "Footwear",
      "parentCategoryId": "men_footwear"
    },
    {
      "name": "Men Sports Shoes",
      "categoryId": "men_sports_shoes",
      "parentCategoryName": "Footwear",
      "parentCategoryId": "men_footwear"
    },
    {
      "name": "Men Formal Shoes",
      "categoryId": "men_formal_shoes",
      "parentCategoryName": "Footwear",
      "parentCategoryId": "men_footwear"
    },
    {
      "name": "Men Sneakers",
      "categoryId": "men_sneakers",
      "parentCategoryName": "Footwear",
      "parentCategoryId": "men_footwear"
    },
    {
      "name": "Men Sandals & Floaters",
      "categoryId": "men_sandals_and_floaters",
      "parentCategoryName": "Footwear",
      "parentCategoryId": "men_footwear"
    },
    {
      "name": "Men Flip Flops",
      "categoryId": "men_flip_flops",
      "parentCategoryName": "Footwear",
      "parentCategoryId": "men_footwear"
    },
    {
      "name": "Men Socks",
      "categoryId": "men_socks",
      "parentCategoryName": "Footwear",
      "parentCategoryId": "men_footwear"
    },
    {
      "name": "Men Sunglasses & Frames",
      "categoryId": "men_sunglasses_and_frames",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Watches",
      "categoryId": "men_watches",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Sports & Active Wear",
      "categoryId": "men_sports_and_active_wear",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Sports Sandals",
      "categoryId": "men_sports_sandals",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Active T-Shirts",
      "categoryId": "men_active_t_shirts",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Track Pants & Shorts",
      "categoryId": "men_track_pants_and_shorts",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Tracksuits",
      "categoryId": "men_tracksuits",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Jackets & Sweatshirts",
      "categoryId": "men_jackets_and_sweatshirts",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Sports Accessories",
      "categoryId": "men_sports_accessories",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Swimwear",
      "categoryId": "men_swimwear",
      "parentCategoryName": "Personal Care & Grooming",
      "parentCategoryId": "men_personal_care_and_grooming"
    },
    {
      "name": "Men Smart Wearables",
      "categoryId": "men_smart_wearables",
      "parentCategoryName": "Gadgets",
      "parentCategoryId": "men_gadgets"
    },
    {
      "name": "Men Fitness Gadgets",
      "categoryId": "men_fitness_gadgets",
      "parentCategoryName": "Gadgets",
      "parentCategoryId": "men_gadgets"
    },
    {
      "name": "Men Headphones",
      "categoryId": "men_headphones",
      "parentCategoryName": "Gadgets",
      "parentCategoryId": "men_gadgets"
    },
    {
      "name": "Men Speakers",
      "categoryId": "men_speakers",
      "parentCategoryName": "Gadgets",
      "parentCategoryId": "men_gadgets"
    },
    {
      "name": "Men Wallets",
      "categoryId": "men_wallets",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Belts",
      "categoryId": "men_belts",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Perfumes & Body Mists",
      "categoryId": "men_perfumes_and_body_mists",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Trimmers",
      "categoryId": "men_trimmers",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Deodorants",
      "categoryId": "men_deodorants",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Ties, Cufflinks & Pocket Squares",
      "categoryId": "men_ties_cufflinks_and_pocket_squares",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Accessory Gift Sets",
      "categoryId": "men_accessory_gift_sets",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Caps & Hats",
      "categoryId": "men_caps_and_hats",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Mufflers, Scarves & Gloves",
      "categoryId": "men_mufflers_scarves_and_gloves",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Phone Cases",
      "categoryId": "men_phone_cases",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Rings & Wristwear",
      "categoryId": "men_rings_and_wristwear",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Helmets",
      "categoryId": "men_helmets",
      "parentCategoryName": "Fashion Accessories",
      "parentCategoryId": "men_fashion_accessories"
    },
    {
      "name": "Men Bags & Backpacks",
      "categoryId": "men_bags_and_backpacks",
      "parentCategoryName": "Bags & Backpacks",
      "parentCategoryId": "men_bags_and_backpacks"
    },
    {
      "name": "Men Luggages & Trolleys",
      "categoryId": "men_luggages_and_trolleys",
      "parentCategoryName": "Bags & Backpacks",
      "parentCategoryId": "men_bags_and_backpacks"
    }
  ]